// extracted by mini-css-extract-plugin
export var arrow = "_41-6";
export var changeItem = "_41-3";
export var changesHeader = "_41-1";
export var changesList = "_41-2";
export var container = "_41-0";
export var pathLabel = "_41-4";
export var value = "_41-7";
export var valuesContainer = "_41-5";